import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import NetworkStatus from './components/NetworkStatus';
import ScreenSizeWarning from './components/ScreenSizeWarning';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <NetworkStatus />
    <ScreenSizeWarning />
    <App />
  </React.StrictMode>
);
